import selectedCartIcon from '../assets/выбранно корзина.png';
import addToFavoritesIcon from '../assets/добавить в избр корзина.png';
import addedToFavoritesIcon from '../assets/в избранном корзина.png';
import deleteIcon from '../assets/удалить.png';

interface CartItemProps {
  id: string;
  image: string;
  title: string;
  price: number;
  quantity: number;
  isSelected: boolean;
  isFavorite: boolean;
  onToggleSelect: (id: string) => void;
  onToggleFavorite: (id: string) => void;
  onDelete: (id: string) => void;
  onQuantityChange: (id: string, delta: number) => void;
}

export default function CartItem({
  id,
  image,
  title,
  price,
  quantity,
  isSelected,
  isFavorite,
  onToggleSelect,
  onToggleFavorite,
  onDelete,
  onQuantityChange,
}: CartItemProps) {
  const formatPrice = (value: number) => new Intl.NumberFormat('ru-RU').format(value);

  return (
    <div
      className={`relative rounded-[20px] bg-white p-4 sm:p-5 ${
        isSelected ? 'shadow-[0_0_20px_0_#5d76cb]' : 'shadow-[0_4px_16px_rgba(0,0,0,0.04)]'
      }`}
    >
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start">
        <div className="relative h-[180px] w-full overflow-hidden rounded-[18px] bg-white sm:h-[220px] lg:h-[200px] lg:w-[220px] lg:flex-shrink-0">
          <img src={image} alt={title} className="h-full w-full object-contain bg-white p-[8px]" />
          <button
            type="button"
            onClick={() => onToggleSelect(id)}
            className={`absolute left-[10px] top-[10px] flex h-[42px] w-[42px] items-center justify-center rounded-[12px] transition-opacity hover:opacity-80 sm:h-[50px] sm:w-[50px] ${
              isSelected ? 'bg-white' : 'border-4 border-[#f3f3f3] bg-white'
            }`}
          >
            {isSelected && <img src={selectedCartIcon} alt="Выбрано" className="h-full w-full object-contain" />}
          </button>
        </div>

        <div className="flex min-w-0 flex-1 flex-col gap-4">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
            <h3 className="max-w-[760px] text-[18px] font-normal leading-[1.35] text-black sm:text-[22px]">{title}</h3>
            <div className="shrink-0 text-left text-[28px] font-bold leading-none text-black sm:text-[34px] lg:pl-4 lg:text-right lg:text-[40px]">
              {formatPrice(price)} ₽
            </div>
          </div>

          <div className="mt-auto flex flex-wrap items-center gap-4">
            <button
              type="button"
              onClick={() => onToggleFavorite(id)}
              className="flex h-[34px] w-[34px] items-center justify-center transition-opacity hover:opacity-80"
            >
              <img
                src={isFavorite ? addedToFavoritesIcon : addToFavoritesIcon}
                alt={isFavorite ? 'В избранном' : 'Добавить в избранное'}
                className="h-full w-full"
              />
            </button>

            <button
              type="button"
              onClick={() => onDelete(id)}
              className="flex h-[34px] w-[34px] items-center justify-center transition-opacity hover:opacity-80"
            >
              <img src={deleteIcon} alt="Удалить" className="h-full w-full object-contain" />
            </button>

            <div className="flex h-[40px] items-center justify-between rounded-[12px] bg-white px-2 shadow-[0_0_5px_0_rgba(0,0,0,0.25)]">
              <button
                type="button"
                onClick={() => onQuantityChange(id, -1)}
                className="flex h-[30px] w-[30px] items-center justify-center rounded-[10px] transition-colors hover:bg-gray-100"
              >
                <div className="h-[2px] w-[12px] rounded-[4px] bg-black" />
              </button>

              <span className="min-w-[36px] px-2 text-center text-[16px] text-black">{quantity}</span>

              <button
                type="button"
                onClick={() => onQuantityChange(id, 1)}
                className="relative flex h-[30px] w-[30px] items-center justify-center rounded-[10px] transition-colors hover:bg-gray-100"
              >
                <div className="h-[2px] w-[12px] rounded-[4px] bg-black" />
                <div className="absolute h-[12px] w-[2px] rounded-[4px] bg-black" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
